<template>
  <div>
      <ul class="nav nav-pills" style="border-bottom: 1px solid rgb(173, 180, 187); box-shadow: rgb(243, 253, 255) 0px 1px 0px;">
        <li v-if="$Behaviors.search.showOccurrence" :class="!$Behaviors.search.modelTabFirst ? 'active' : ''"><a data-toggle="tab" href="#criteria_tab">{{$Jed.firstUpperTranslate('components')}}</a></li>
        <li v-if="$Behaviors.search.showGlobal"><a data-toggle="tab" href="#global_tab">{{$Jed.firstUpperTranslate('global')}}</a></li>
        <li v-if="$Behaviors.search.showModel" :class="$Behaviors.search.modelTabFirst ? 'active' : ''"><a data-toggle="tab" href="#model_tab">{{$Jed.firstUpperTranslate('model')}}</a></li>
        <li v-if="$Behaviors.search.showMarketing"><a data-toggle="tab" href="#marketing_tab">{{$Jed.firstUpperTranslate('marketing')}}</a></li>
        <li v-if="$Behaviors.search.showMerchandising"><a data-toggle="tab" href="#merchandising_tab">{{$Jed.firstUpperTranslate('merchandising')}}</a></li>
      </ul>

      <div class="tab-content">

        <div v-if="$Behaviors.search.showOccurrence" :class="!$Behaviors.search.modelTabFirst ? 'active' : ''" id="criteria_tab" class="tab-pane" style="overflow-y: auto;">
          
          <search-form :type="'criteria'" :right="right" @resetHeight="setResultsHeight" :categoria="$store.getters.getCategory" :modello="$store.getters.getModel"></search-form>
      
          <!--criteri di ricerca applicati-->
          <div style="margin-top: 40px;" id="criteria"> <!--margin-left: 30px;-->
            <span v-for="(c, index) in criteriaArray" class="applied-filter" :id="'lbl-'+criteriaArray[index].field">
              <label style="font-weight: 400 !important;">{{criteriaArray[index].label}}: {{criteria[criteriaArray[index].field]}}</label>
              <!--<a style="color: #666666d9; cursor: pointer;" @click="removeCriterion(criteriaArray[index].field)"><i :class="$root.icons.cancel"></i></a>-->
            </span>
          </div>

          <div style="min-height: 300px;">
          <!--<transition name="expand">-->
            <div v-if="tableVisible">
              <search-results id="criteriaResults" :source.sync="arrayToTable" :maxRes="maxRes" :modelNotFound="showModelWarn" :type="'criteria'"></search-results>
            </div>  
          <!--</transition>-->
            <label v-show="no_search_results" style="margin-left: 40px; margin-top: 30px; color: #757575; display: none;">{{$Jed.firstUpperTranslate('no search results')}}</label>
          </div>
          
          <!--<waiter v-if="doing_search" style="position: absolute; top: 150px; right: 0px; left: 50px;"></waiter>-->
          <div v-if="doing_search" class="sk-cube-grid" style="position: absolute; top: 150px; right: 0px; left: 50px;">
            <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
          </div>
          
        </div>

        <div v-if="$Behaviors.search.showGlobal" id="global_tab" class="tab-pane">
          <ul style="padding-top: 20px; padding-left: 20px;">
            <table style="width: 100%;">
              <td>
                <input-w>
                  <input style="width:97%;" type="text" class="searchfield" placeholder="Cerca..." v-model="global_filter">
                </input-w> 
              </td>
              <td>
                <button class="btn btn-primary" style="padding: 2px 5px; border-radius: 2px;">
                  <i :class="$root.icons.clear" aria-hidden="true" style="margin-left: 0px;"></i>
                </button>
              </td>
              </tr>
            </table>
            
            <!--spinner-->
            <div v-if="doing_global_search" class='uil-rolling-css loading-nav-spinner' style='transform:scale(0.50);  
              position: absolute; margin: 0 auto; top: 150px; right: 0px; left: 50px;'>
              <div>
                <div></div>
                <div></div>
              </div>
            </div> 

          </ul>

          <div v-if="globaltableVisible" class="resultsTable"> 

          </div>  
          <label v-show="no_search_results" style="margin-left: 40px; margin-top: 30px; color: #757575; display: none;">{{$Jed.firstUpperTranslate('no search results')}}</label>

        </div>

        <div v-if="$Behaviors.search.showModel" :class="$Behaviors.search.modelTabFirst ? 'active' : ''" id="model_tab" class="tab-pane">
          
          <!--Form ricerca configurato per il tab "modello"-->
          <search-form :type="'model'" :right="right" @resetHeight="setResultsHeight"></search-form>

          <!--Area con i risultati della ricerca modello-->
          <div style="min-height: 300px; margin-top: 30px;">
            <div v-if="tableVisible">
              <search-results id="filterResults" :source.sync="modelArrayToTable" :maxRes="maxRes" :type="'filter'"></search-results>
            </div>
            <label v-show="no_model_results" style="margin-left: 40px; margin-top: 30px; color: #757575; display: none;">{{$Jed.firstUpperTranslate('no search results')}}</label>
          </div>
          
          <!--Loader per l'attesa dei risultati della ricerca-->
          <div v-if="doing_search" class="sk-cube-grid" style="position: absolute; top: 150px; right: 0px; left: 50px;">
            <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
          </div>
        </div>

        <div v-if="$Behaviors.search.showMarketing" id="marketing_tab" class="tab-pane">

          <!--Form ricerca configurato per il tab "marketing" (articoli di stampa)-->
          <search-form :type="'marketing'" :right="right" @resetHeight="setResultsHeight"></search-form>

          <!--Area con i risultati della ricerca marketing-->
          <div style="min-height: 300px; margin-top: 30px;">
            <div v-if="tableVisible">
              <search-results id="filterResults" :source.sync="mktingArrayToTable" :maxRes="maxRes" :type="'filter'"></search-results>
            </div>  
            <label v-show="no_mark_results" style="margin-left: 40px; margin-top: 30px; color: #757575; display: none;">{{$Jed.firstUpperTranslate('no search results')}}</label>
          </div>
          
          <!--Loader per l'attesa dei risultati della ricerca-->
          <div v-if="doing_search" class="sk-cube-grid" style="position: absolute; top: 150px; right: 0px; left: 50px;">
            <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
          </div>
        </div>

        <div v-if="$Behaviors.search.showMerchandising" id="merchandising_tab" class="tab-pane">

          <!--Form ricerca configurato per il tab "merchandising" (abbigliamento)-->
          <search-form :type="'merchandising'" :right="right" @resetHeight="setResultsHeight"></search-form>

          <!--Area con i risultati della ricerca merchandising-->
          <div style="min-height: 300px; margin-top: 30px;">
            <div v-if="tableVisible">
              <search-results id="filterResults" :source.sync="mrdingArrayToTable" :maxRes="maxRes" :type="'filter'"></search-results>
            </div>  
            <label v-show="no_merch_results" style="margin-left: 40px; margin-top: 30px; color: #757575; display: none;">{{$Jed.firstUpperTranslate('no search results')}}</label>
          </div>
          
          <!--Loader per l'attesa dei risultati della ricerca-->
          <div v-if="doing_search" class="sk-cube-grid" style="position: absolute; top: 150px; right: 0px; left: 50px;">
            <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
          </div>
        </div>
      </div>

	</div>
</template> 

<script>
  import { eventBus } from "../eventbus.js";
  import SearchForm from "./menu-components/SearchForm.vue";
  import SearchResults from "./menu-components/SearchResults.vue";
  import dynButton from "./dynamic/DynButton.vue";
  import InputW from './dynamic/inputWrapper/inputWrapper.vue'
  import search_mixin from '../mixins/search_mixin.js';

  var vm;
  $(window).resize(function() {
    if (vm != null) {
      vm.setResultsHeight();
      vm.setContainerHeight();
    }
  });

  export default {
    created: function() {
      vm = this;

      eventBus.$on('readyFields', function(fields){ //renderizzo le etichette coi criteri (inizialmente sono nascoste)
        for(var i=0;i<fields.length;i++){
          vm.criteriaArray.push(fields[i])
        }
      });

      eventBus.$on('tableVisible', function(data, maxRes, type, mod_matr){
        vm.doing_search = false;
        vm.tableVisible = true; //mostro la tabella dei risultati
        vm.maxRes = maxRes;
        if(vm.criteria.mat){ //la matricola era richiesta?
          vm.showModelWarn = mod_matr && mod_matr.modello ? false : true;
        }else{
          vm.showModelWarn = false;
        }
        
        if(type == 'criteria'){
          /*mostro i filtri applicati: se una delle etichette che erano già state renderizzate 
          ha una corrispondenza nell'oggetto che contiene i filtri applicati(data) 
          se non è vuota o undefined
          allora la mostro con il valore del criterio inserito in input*/
          $('#criteria').show(); 
          for(var f in vm.criteriaArray){ 
            if(vm.criteriaArray[f].field in data && data[vm.criteriaArray[f].field] != "" && data[vm.criteriaArray[f].field] != undefined){ 
              vm.criteria = data
              $('#lbl-'+ vm.criteriaArray[f].field ).show();
            }else{
              $('#lbl-'+ vm.criteriaArray[f].field ).hide();
            }
          }
        }
        
        vm.setResultsHeight()
      });

      eventBus.$on('tableData', function(data, ftype){
          vm.arrayToTable = []
          vm.modelArrayToTable = []
          vm.mktingArrayToTable = []
          vm.mrdingArrayToTable = []
          for(var e in data){
            var elem = data[e]
            console.log('elem: ',elem)
            if(vm.$Behaviors.search.fathersDescriptions && vm.$Behaviors.search.fathersDescriptions.length>0 && elem.fathers){
              for(var f in elem.fathers){
                var fath = elem.fathers[f];
                console.log('fath: ',fath)
                if(fath.idp && typeof fath.idp == 'string'){
                  var myvar = fath.idp
                  var path = fath.idp.split('?')
                  if(elem.typ!="Modello"){
                    // nei risultati mi è più comodo presentare il percorso come array (escludendo radice e ultimo nodo (padre))
                    path = path.splice(1, path.length - 2);
                  }
                  fath["a_idp"] = path.join("?");
                  path.reverse();
                  elem.fathers[f].idp = path;
                }
                if(fath.idpdes && typeof fath.idpdes == 'string'){
                  var path = fath.idpdes.split('?')
                  path.pop()                
                  elem.fathers[f].idpdes = path;
                  if(elem.typ=="Modello"){
                    elem.fathers[f].idpdes.push(elem.des)
                  }
                }
              }

              let sortBy = [{
                prop: 'idpdes',
                lev: 0,
                direction: -1
              },{
                prop: 'idpdes',
                lev: 1,
                direction: 1
              },{
                prop: 'idpdes',
                lev: 2,
                direction: 1
              },{
                prop: 'idpdes',
                lev: 3,
                direction: 1
              }];

              elem.fathers.sort(function(a,b){
                let i = 0, result = 0;
                while(i < sortBy.length && result === 0 && a[sortBy[i].prop][sortBy[i].lev] && b[sortBy[i].prop][sortBy[i].lev]) {
                  result = sortBy[i].direction*(a[sortBy[i].prop][sortBy[i].lev].toLowerCase() < b[sortBy[i].prop][sortBy[i].lev].toLowerCase() ? -1 : (a[sortBy[i].prop][sortBy[i].lev].toLowerCase() > b[sortBy[i].prop][sortBy[i].lev].toLowerCase() ? 1 : 0));
                  i++;
                }
                return result;
              })
            }
            if(ftype == 'criteria'){
              vm.arrayToTable.push({
                typ: elem.typ,
                cod: elem.id,
                spi: elem.spi,
                des: elem.des,
                occ: elem.fathers.length,
                fat: vm.$root.preferences.splitSearch ? null : elem.fathers,
                mod: elem.modello,
                gra: elem.gra
              });
            }else if(ftype == 'model'){
              vm.modelArrayToTable.push({
                cod: elem.id,
                des: elem.des,
                fat: elem.fathers,
                gra: elem.gra,
                typ: elem.typ
              });
            }else if(ftype == 'mkting'){
              vm.mktingArrayToTable.push({
                cod: elem.id,
                des: elem.des,
                fat: elem.fathers,
                gra: elem.gra,
                doc: elem.doc,
                typ: elem.typ
              });
            }else if(ftype == 'merchandising'){
              vm.mrdingArrayToTable.push({
                cod: elem.id,
                des: elem.des,
                fat: elem.fathers,
                gra: elem.gra,
                typ: elem.typ
              })
            }
          }
      })

      eventBus.$on('hideTable', function(){
        vm.tableVisible = false;
        vm.doing_search = true;
        vm.no_search_results = false;
        vm.no_model_results = false;
        vm.no_mark_results = false;
        vm.no_merch_results = false;
        $('#criteria').hide(); 
      })

      eventBus.$on('no_search_results', function(){
        vm.doing_search = false;
        vm.no_search_results = true;
      })
      eventBus.$on('no_model_results', function(){
        vm.doing_search = false;
        vm.no_model_results = true;
      })
      eventBus.$on('no_mark_results', function(){
        vm.doing_search = false;
        vm.no_mark_results = true;
      })
      eventBus.$on('no_merch_results', function(){
        vm.doing_search = false;
        vm.no_merch_results = true;
      })

      eventBus.$on('search_done', function(){
        vm.doing_search = false;
      })
    },
    mounted: function(){
      var vm = this;
      $('a[data-toggle="tab"').on('shown.bs.tab', function(event){ 
        var x = event.target.hash; // active tab
        var y = event.relatedTarget.hash; // previous tab
        x = x.replace('#','')
        x = x.replace('_tab','')
        vm.type = x
      });
    },
    props: {
      right: Boolean, //configurazione che regola se l'albero è da disporre a destra o a sinistra
      configs: {
        type: Object,
        default: function() {
          return {
            ID: "mainForm.navTree",
            showId: false,
            showValidity: false
          };
        }
      }
    },
    components: {
      SearchForm,
      SearchResults,
      InputW,
      dynButton
    },
    mixins: [search_mixin],
    data: function() {
      var vm = this;
      return {
        ready: false,
        arrayToTable: [],
        modelArrayToTable: [],
        mktingArrayToTable: [],
        mrdingArrayToTable: [],
        fathersArray: [],
        focus: null,
        tableVisible: false,
        criteriaArray: [],
        criteria: {},
        doing_search: false,
        global_filter: '',
        globaltableVisible: false,
        doing_global_search: false,
        globalarrayToTable: [],
        maxRes: null,
        showModelWarn: false,
        no_search_results: false,
        no_model_results: false,
        no_mark_results: false,
        no_merch_results: false
      };
    },
    methods: {
      setResultsHeight: function() {
        if(this.tableVisible){
          this.$nextTick(function(){    
            var h = window.innerHeight;
            
            try {
              var formh =  document.getElementById('sidebarSearchForm').offsetHeight;
              //windowHeight - formHeight - formMargin - navbar - searchTabs - searchParams  - result headers
              var elab = h - (formh + 20 + 55 + 45 + 25 + 50);
              document.getElementById("criteriaResults").style.maxHeight = elab + "px";
              document.getElementById("filterResults").style.maxHeight = elab + "px";
            } catch(err){}
            
          })
        }
      },
      setContainerHeight: function(){
        this.$nextTick(function(){
          var h = window.innerHeight;
          var conth = h - 100;

          try {
             if(conth > 700){
              document.getElementById("criteria_tab").style.maxHeight = "unset";
            } else {
              document.getElementById("criteria_tab").style.maxHeight = conth + "px";
            }
          } catch(err){}
         
        })
      },
      /* removeCriterion: function(id){
        $('#'+ id ).hide();
        eventBus.$emit('emptyfield', id);
      }, */
      rowInteraction: function(row){
        if(row.name=='rowexpand'){ //se ho espanso la riga
          var pad = this.arrayToTable[row.event.args.rowindex].fat
          if(pad.length==1){ //se ha solo un padre, navigo direttamente
            for(var i in pad){
              for(var j in pad[i]){
                var idp
                if(pad[i][j].cco>0){  //se ha figli (cioè, l'elemento nella riga dalla tabella padre non è una Parte)
                  var focus = pad[i][j].pos
                  idp = pad[i][j].idp.split('?');
                  idp.pop()
                  idp.pop()
                  var str = ''
                  for(var k in idp){
                    str += idp[k]+'?'
                  }
                  this.$root.navigateTo(pad[i][j].id, str, focus); //navigo senza focus
                }else{ //l'id è il padre, il navigation_path arriva al nonno e focus è la posizione(o codice) del prodotto
                  idp = pad[i][j].idp.split('?');
                  idp.pop()
                  idp.pop()
                  var string = ''
                  for(var k in idp){
                    string += idp[k]+'?'
                  }
                  this.$root.navigateTo(pad[i][j].id, string, pad[i][j].pos); //navigo con focus 
                }
              }
            }
          }
        }
      }
    }
  };
</script>

<style scoped>

  .nav-pills>li.active>a, .nav-pills>li.active>a:hover{
    background-color: #9da2a596; 
    border-right-color: rgb(221, 221, 221);
    border-right-style: groove;
    border-right-width: 1px;
    border-left-color: rgb(221, 221, 221);
    border-left-style: groove;
    border-left-width: 1px;
    color: rgb(236, 240, 245) !important;
    font-weight: 500;
    cursor: context-menu;
  }

  .nav-pills>li>a:hover{
    background-color: #6d72757d;
  }

  .applied-filter{
    background-color: #ddd;
    border-radius: 4px;
    padding: 2px;
    margin-left: 10px;
    display: none;
  }

  .sidebar-collapse #criteria {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchMenu.vue?13259e9e